import React, {useState} from 'react';
import {Box, Card, CardContent, Container} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Link, Redirect, useHistory} from "react-router-dom";
import {getNavigationUrl} from '../navigation';
import AppBar from "../Components/AppBar";
import Typography from "@material-ui/core/Typography";
import {useAuth} from "../hooks/auth";
import LoginForm from "../Components/Forms/LoginInForm";
import SignUpForm from "../Components/Forms/SignUpForm";
import {Trans, useTranslation} from "react-i18next";
import {useAPI} from "../../../lib/common";
import {useShoppingCart} from "../hooks/shoppingcart";
import {usePriceList} from "../../Providers/PriceListProvider";
import VerifyMinimumPrice from "./VerifyMinimumPrice";
import AutoCorrectionDialog from "./AutoCorrectionDialog";

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  margin: {
    marginBottom: theme.spacing(2),
  },
  card: {
    backgroundColor: 'white',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: '0px 2px 4px #00000029',
  }
}));

export default () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useAuth();
  const {totalPrice, loading} = useShoppingCart();
  const {state} = usePriceList();
  const [minimumPriceAccepted, setMinimumPriceAccepted] = useState(false);
  const [askedForAutoCorrect, setAskedForAutocorrect] = useState(false);
  const [t] = useTranslation();

  const onLogin = () => {
    history.push(getNavigationUrl('CHECKOUT_DELIVERY'))
  }

  if (loading) {
    return <div>{t('Loading')}</div>
  }

  console.log('State:', state.minimumPrice, totalPrice, minimumPriceAccepted);
  if (state.minimumPrice > totalPrice && !minimumPriceAccepted) {
    return <React.Fragment>
      <AppBar />
      <Container maxWidth="sm">
        <VerifyMinimumPrice totalPrice={totalPrice} minimumPrice={state.minimumPrice}
                            handleAcceptMinimumPrice={() => setMinimumPriceAccepted(true)} />
      </Container>
    </React.Fragment>
  }

  console.log('Config', window.NTLF_CONFIG.portal);

  if (window.NTLF_CONFIG.portal.options['checkout-ask-for-auto-correction'] && !askedForAutoCorrect) {
    return <React.Fragment>
      <AppBar />
      <Container maxWidth="sm">
        <AutoCorrectionDialog handleQuestionAsked={() => setAskedForAutocorrect(true)} />
      </Container>
    </React.Fragment>
  }

  // If we're logged in, skip this step:
  if (user) {
    return <Redirect to={getNavigationUrl('CHECKOUT_DELIVERY')} />
  }

  return <React.Fragment>
    <AppBar />
    <Container maxWidth="sm" disableGutters={true}>
      <div className={classes.card}>
          <Typography variant="h4">
            <Trans>Already registered</Trans>
          </Typography>
          <Typography variant="h6">
            <Trans>Log in</Trans>
          </Typography>
          <LoginForm onLogin={onLogin}/>
      </div>

      <div className={classes.card}>
        <Typography variant="h4">
          <Trans>Pay as guest</Trans>
        </Typography>
        <Typography variant="h6">
          <Trans>Registration is not required</Trans>
        </Typography>
        <Box mb={2} mt={2}>
          <Button variant="contained" color="primary" fullWidth
                  component={Link} to={getNavigationUrl('CHECKOUT_DELIVERY')}>
            <Trans>Pay as guest</Trans>
          </Button>
        </Box>
      </div>

      <div className={classes.card}>
        <Typography variant="h4">
          <Trans>New user</Trans>
        </Typography>
        <Typography variant="h6">
          <Trans>Registration</Trans>
        </Typography>
        <SignUpForm onSignUpSuccess={onLogin} />
      </div>
    </Container>

  </React.Fragment>
}

